export function createUrlWithParams(params: string) {
  return [
    window.location.protocol,
    '//',
    window.location.host,
    window.location.pathname,
    '?',
    params,
  ].join('');
}
